<mat-dialog-content>
    <div class="modal-shopping">
        <div class="modal-shopping__header">
            <button type="button" (click)="onNoClick()"><span class="icon icon-close"></span></button>
        </div>
        <div class="modal-shopping__body">
            <div class="resume">
                <legend class="resume__title">Resumen de tu compra</legend>

                <div class="grid resume__item" *ngFor="let item of planSelected; index as i">
                    <div class="grid grid-8 description">
                        <img class="grid-3" src="{{image_url}}shopping-{{item.image_url}}.png" alt="base estandar">
                        <h4 class="grid-9 description__type pl-tiny">{{item.name}}<span class="description__price">${{item.priceDiscount.toLocaleString()}}</span></h4>
                    </div>
                </div>

                <div class="grid resume__item" *ngFor="let item of aditionalProducts">
                    <div class="grid grid-8 description">
                        <img class="grid-3" src="{{image_url}}shopping-{{item.image_url}}.png" alt="recorrido 3d">
                        <h4 class="grid-9 description__type pl-tiny">{{item.name}}<span class="description__price">${{item.priceDiscount.toLocaleString()}}</span></h4>
                    </div>
                    <div class="grid-4 picker-group">
                        <span>{{item.quantity}}</span>
                    </div>
                </div>

                <div class="alert alert-bg-warning mt-xsmall icon-icon-pop" *ngIf="this.planSelected.length === 0 && userPrivateZone == false && idStatus == 0">
                    <p class="text-small ml-mid">
                        Debe tener un plan agregado en el carrito.
                    </p>
                </div>

                <div class="resume__pay" *ngIf="havePlan === false && (planSelected.length >= 1 || aditionalProducts.length > 0)">
                    <div class="total">
                        <span class="total__number"> Productos <span class="counter">{{count}}</span></span>
                        <p class="total__text">Total de tu compra</p>
                        <span class="total__value">${{summary.toLocaleString()}}</span>

                    </div>

                    <button type="submit" class="button secondary rounded block" (click)='consultingInformation()'>Pagar</button>

                    <button type="button" class="btn" (click)='removeall()'>Vaciar carrito</button>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>